import React from 'react';
import { Calendar, Star, FileText, MessageSquare } from 'lucide-react';

const CourseProgressSection = ({ studentData }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed': return '#4CAF50';
      case 'in progress': return '#FF9800';
      case 'not started': return '#9E9E9E';
      default: return '#2196F3';
    }
  };

  if (!studentData?.courseDetails) {
    return (
      <div className="profile-section">
        <h2>Course Progress</h2>
        <p>No course details available.</p>
      </div>
    );
  }

  const cd = studentData.courseDetails;

  const displayScore = (score) => {
    if (score === null || score === undefined || score === '') return '0/10';
    return `${score}/10`;
  };

  return (
    <div className="profile-sections">

      <div className="info-grid">
  
        <div className="info-item">
          <label>Course Start Date</label>
          <span><Calendar size={16} /> {formatDate(cd.courseStartDate)}</span>
        </div>

        <div className="info-item">
          <label>Course End Date</label>
          <span><Calendar size={16} /> {formatDate(cd.courseEndDate)}</span>
        </div>

        {/* Technical Score + Remarks */}
        <div className="info-item">
          <label>Technical Score</label>
          <span><Star size={16} /> {displayScore(cd.technicalScore)}</span>
          <p style={{ marginTop: "4px", fontSize: "14px", color: "#555" }}>
           Remarks:  {cd.technologyRemarks || "No technical remarks"}
          </p>
        </div>

        {/* Communication Score + Remarks */}
        <div className="info-item">
          <label>Communication Score</label>
          <span><Star size={16} /> {displayScore(cd.communicationScore)}</span>
          <p style={{ marginTop: "4px", fontSize: "14px", color: "#555" }}>
            Remarks: {cd.communicationRemarks || "No communication remarks"}
          </p>
        </div>
      </div>

      {/* Mock Test Scores Section */}
      <div className="scores-section">
        <h3>Mock Test Scores</h3>
        <div className="score-grid">
          <div className="score-item">
            <label>Mock Test 1</label>
            <span className="score">{displayScore(cd.mockTest1Score)}</span>
          </div>
          <div className="score-item">
            <label>Mock Test 2</label>
            <span className="score">{displayScore(cd.mockTest2Score)}</span>
          </div>
          <div className="score-item">
            <label>Mock Test 3</label>
            <span className="score">{displayScore(cd.mockTest3Score)}</span>
          </div>
        </div>
      </div>

      {/* Projects Section */}
      <div className="projects-section">
        <h3>Projects</h3>
        <div className="project-grid">
          {[1, 2, 3].map((num) => {
            const title = cd[`projectTitle${num}`];
            const status = cd[`project${num}Status`];
            const score = cd[`project${num}Score`];
            const feedback = cd[`project${num}Feedback`];

            // Skip completely empty project
            if (!title && !status && !score && !feedback) return null;

            return (
              <div className="project-item" key={num}>
                <div className="project-header">
                  <h4>{title || `Project ${num}`}</h4>
                  <span
                    className="project-status"
                    style={{ backgroundColor: getStatusColor(status) }}
                  >
                    {status || 'Not Started'}
                  </span>
                </div>

                <div className="project-score">
                  <FileText size={16} />
                  Score: {displayScore(score)}
                </div>

                {/* ⭐ Project Feedback (single line under score) */}
                <p style={{ marginTop: "6px", fontSize: "14px", color: "#555" }}>
                  <MessageSquare size={14} style={{ marginRight: '5px' }} />
                   Feedback: {feedback || "No feedback provided"}
                </p>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default CourseProgressSection;
